import createEntityFeedbackEntry from './createEntityFeedbackEntry';
import EntityAddSource from 'owa-service/lib/contract/EntityAddSource';
import EntityFeedbackEntry from 'owa-service/lib/contract/EntityFeedbackEntry';
import {
    eventType,
    FeedbackManagerState,
} from 'owa-feedback-manager-store/lib/store/schema/FeedbackManagerState';

/**
 * Creates a EntityFeedbackEntry for the specified feedback manager and event type.
 * @param feedbackManagerState: the feedback manager state
 * @param eventType: the feedback event type to submit
 */
export default function createSessionFeedbackEntry(
    feedbackManagerState: FeedbackManagerState,
    eventType: eventType
): EntityFeedbackEntry {
    let jsonPropertyBagDictionary = {
        ScenarioName: feedbackManagerState.entityScenarioName,
    };
    let jsonPropertyBag = JSON.stringify(jsonPropertyBagDictionary);

    return createEntityFeedbackEntry(
        feedbackManagerState,
        '' /* transactionId*/,
        eventType,
        '' /* targetEntityList*/,
        EntityAddSource.None,
        jsonPropertyBag
    );
}
